import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import firebase from './plugins/firebase'
import axios from './plugins/axios'
import vueDaumPostcode from 'vue-daum-postcode'
import VueCookie from 'vue-cookies'
import VueKakaoSdk from 'vue-kakao-sdk'
import './error'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  firebase,
  axios,
  // VueCookie,
  render: h => h(App)
}).$mount('#app')

Vue.use(vueDaumPostcode)

Vue.use(VueCookie)

// 카카오 메시지 REST API 이용
// window.kakao.init('5dd00b5150adbc35a5e8ae442064a075')
// 카카오 sdk이용 (javascript key)
const apiKey = '2d91bae1654af0bf8b3e7b6acbdaf16c'
Vue.use(VueKakaoSdk, { apiKey })
